import APIClient from '@/request'

import auth from './auth'
import account from './account'
import shop from './shop'
import reservations from './reservations'
import businessHours from './business-hours'
import staffs from './staffs'
import shifts from './shifts'
import menus from './menus'
import dyestuffs from './dyestuffs'
import hotpepperMails from './hotpepper-mails'
import operationHistories from './operation-histories'

import analytics from './admin/analytics'

function subAPIs (cli) {
  cli.auth = auth(cli)
  cli.accounts = account(cli)
  cli.shops = shop(cli)
  cli.reservations = reservations(cli)
  cli.businessHours = businessHours(cli)
  cli.staffs = staffs(cli)
  cli.shifts = shifts(cli)
  cli.menus = menus(cli)
  cli.dyestuffs = dyestuffs(cli)
  cli.hotpepperMails = hotpepperMails(cli)
  cli.analytics = analytics(cli)
  cli.operationHistories = operationHistories(cli)
}

const client = new APIClient(process.env.API_ENDPOINT, process.env.API_ENDPOINT_V2, subAPIs)

client.install = function (Vue) {
  Object.defineProperty(Vue.prototype, '$request', {
    get () {
      return client
    },
  })
}

export default client



// WEBPACK FOOTER //
// ./src/api/index.js